export default __webpack_public_path__ + "static/media/Background_00279.96931cd3.png";